import { request } from "@esri/arcgis-rest-request";
import { getPortalUrl } from "../util/get-portal-url";
import { determineOwner } from "./helpers";
/**
 * ```js
 * import { getUserContent } from "@esri/arcgis-rest-portal";
 * //
 * getUserContent({
 *    owner: 'geemike',
 *    folderId: 'bao7',
 *    start: 1,
 *    num: 20,
 *    authentication
 * })
 * ```
 * Returns a listing of the user's content. If the `username` is not supplied, it defaults to the username of the authenticated user. If `start` is not specificed it defaults to the first page.
 * If the `num` is not supplied it is defaulted to 10. See the [REST Documentation](https://developers.arcgis.com/rest/users-groups-and-items/user-content.htm) for more information.
 *
 * @param requestOptions - Options for the request
 * @returns A Promise<IUserContentResponse>
 */
export var getUserContent = function (requestOptions) {
    var folder = requestOptions.folderId, _a = requestOptions.start, start = _a === void 0 ? 1 : _a, _b = requestOptions.num, num = _b === void 0 ? 10 : _b, authentication = requestOptions.authentication;
    var suffix = folder ? "/" + folder : "";
    return determineOwner(requestOptions)
        .then(function (owner) { return getPortalUrl(requestOptions) + "/content/users/" + owner + suffix; })
        .then(function (url) { return request(url, {
        httpMethod: "GET",
        authentication: authentication,
        params: {
            start: start,
            num: num,
        },
    }); });
};
//# sourceMappingURL=content.js.map